/**
 * service
 */
/**
 * const
 */
import {
    ACCESS_TOKEN_KEY,
    REFRESH_TOKEN_KEY,
    LANG_CODE_KEY, ACCESS_COR_ID_TOKEN_KEY, REFRESH_COR_ID_TOKEN_KEY,
} from "../constants/storage.constant";


export default class StorageService {
    static get accessToken(): string | null {
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    }

    static set accessToken(value: string | null) {
        if (value) {
            localStorage.setItem(ACCESS_TOKEN_KEY, value);
        } else {
            localStorage.removeItem(ACCESS_TOKEN_KEY);
        }
    }
    static get accessCorIdToken(): string | null {
        return localStorage.getItem(ACCESS_COR_ID_TOKEN_KEY);
    }

    static set accessCorIdToken(value: string | null) {
        if (value) {
            localStorage.setItem(ACCESS_COR_ID_TOKEN_KEY, value);
        } else {
            localStorage.removeItem(ACCESS_COR_ID_TOKEN_KEY);
        }
    }

    static get refreshToken(): string | null {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    }

    static set refreshToken(value: string | null) {
        if (value) {
            localStorage.setItem(REFRESH_TOKEN_KEY, value);
        } else {
            localStorage.removeItem(REFRESH_TOKEN_KEY);
        }
    }

    static get refreshCorIdToken(): string | null {
        return localStorage.getItem(REFRESH_COR_ID_TOKEN_KEY);
    }

    static set refreshCorIdToken(value: string | null) {
        if (value) {
            localStorage.setItem(REFRESH_COR_ID_TOKEN_KEY, value);
        } else {
            localStorage.removeItem(REFRESH_COR_ID_TOKEN_KEY);
        }
    }

    static get langCode(): string | null {
        return localStorage.getItem(LANG_CODE_KEY);
    }

    static set langCode(value: string | null) {
        if (value) {
            localStorage.setItem(LANG_CODE_KEY, value);
        } else {
            localStorage.removeItem(LANG_CODE_KEY);
        }
    }

    static clear(): void {
        localStorage.clear();
    }

    static removeTokens(): void {
        this.accessToken = null;
        this.refreshToken = null;
        this.accessCorIdToken = null;
        this.refreshCorIdToken = null;
    }
}
